import ExifReader from 'exifreader';
import { unslug } from '@/utils/index';

export async function getImageExifTags(file) {
  try {
    return ExifReader.load(file);
  } catch (e) {
    return {};
  }
}
export function extractTagByName(tags, name) {
  if (tags[name] && tags[name].description.toString().trim()) {
    return tags[name].description.toString().trim();
  }
  return null;
}

export async function getImageAuthor(file) {
  if (!file || file.type || !file.type.startsWith('image')) {
    return null;
  }
  try {
    const tags = await getImageExifTags(file);
    const candidates = [
      'Artist',
      'XPAuthor',
      'creator',
      'description',
    ];
    const tag = candidates.find(candidate => !!extractTagByName(tags, candidate));
    if (tag) {
      return extractTagByName(tags, tag);
    }
  } catch (e) {
    console.error(e);
  }

  return null;
}

export async function getImageDescription(file) {
  if (!file) {
    return null;
  }
  if (!file.type || !file.type.startsWith('image')) {
    return getFileName(file);
  }
  try {
    const tags = await getImageExifTags(file);
    const candidates = [
      'title',
      'ImageDescription',
      'XPTitle',
    ];
    const tag = candidates.find(candidate => !!extractTagByName(tags, candidate));

    if (tag) {
      return extractTagByName(tags, tag);
    }
  } catch (e) {
    console.error(e);
  }

  return getFileName(file);
}

export function getFileName(file) {
  if (!file) {
    return null;
  }
  if (file.name) {
    return unslug(file.name.replace(/\.[^/.]+$/, ''));
  }
  return null;
}
